<template>
  <div>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="日期：">
        <el-date-picker v-model="inputDate" type="month" :default-value="new Date()" @change="changeDate"
          :clearable="false" value-format="yyyy-MM" placeholder="选择日期" :editable="false" format="yyyy年MM月"
          size="small">
        </el-date-picker>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-radio-group v-model="echartType" border @input="changeChartType">
          <el-radio-button label="category">柱状图</el-radio-button>
          <el-radio-button label="line">折线图</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="statisticChart"></div>
  </div>
</template>

<script>
import { GetJGBMonthKDStatistic } from "@/api/storeOrderApi.js";
import * as echarts from "echarts";
export default {
  data() {
    return {
      loading: false,
      statisticData: {
        xnameList: [],
        num1List: [],
        num2List: [],
        num3List: [],
        num4List: [],
        num5List: [],
      },
      formInline: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
      },
      echartType: "category",
      inputDate: new Date(),
    };
  },
  components: {},

  created() {

  },

  mounted() {
    // First initialize the chart with proper sequence
    this.initChart();
    // Then load data
    this.GetJGBMonthKDStatistic(this.formInline);
  },

  methods: {
    // Switch chart type between bar and line
    changeChartType() {
      // Check if chart instance exists before operating
      if (!this.chart || this.chart.isDisposed()) {
        // If not, get container and create new instance
        const chartDom = document.querySelector(".statisticChart");
        if (chartDom) {
          this.chart = echarts.init(chartDom);
        } else {
          console.error("Chart container not found");
          return;
        }
      }

      const chartTitlePre = this.formInline.year + "年" + this.formInline.month + "月加工快递数量统计"
      // 根据图表类型设置配置
      const isBarChart = this.echartType === 'category';
      const chartTitle = chartTitlePre + (isBarChart ? '柱状图' : '折线图');
      const chartType = isBarChart ? 'bar' : 'line';
      const axisPointerType = isBarChart ? 'shadow' : 'line';

      // 设置图表选项
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: axisPointerType,
          },
        },
        title: {
          text: chartTitle,
          left: "center",
          textStyle: {
            color: "#333",
            fontSize: 18,
          },
          // 调整标题位置，为legend留出空间
          top: "10px"
        },
        // 添加legend组件，允许用户选择显示哪些数据系列
        legend: {
          data: ["订单完成总数", "快递单数", "今日取镜订单数", "明日取镜订单数", "后天取镜订单数"],
          // 水平居中显示在标题下方
          top: "40px",
          left: "center",
          // 设置选中和未选中的样式
          textStyle: {
            color: "#666"
          },
          // 允许多选，但通过事件处理确保至少保留一个选中项
          selectedMode: "multiple"
        },
        grid: {
          left: "2%",
          right: "5%",
          bottom: "2%",
          // 为legend留出顶部空间
          top: "100px",
          containLabel: true,
        },
        xAxis: {
          name: "日期",
          type: "category",
          data: this.statisticData.xnameList,
          axisLabel: {
            interval: 0,
            rotate: 30,
          },
        },
        yAxis: {
          type: "value",
          name: "数量",
        },
        series: [
          {
            name: "订单完成总数",
            type: chartType,
            data: this.statisticData.num1List,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#409eff",
                },
                {
                  offset: 1,
                  color: "#73c0de",
                },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#2a6fc9",
                  },
                  {
                    offset: 1,
                    color: "#409eff",
                  },
                ]),
              },
            },
            label: {
              show: true,
              position: isBarChart ? "top" : "top",
            },
            // 折线图特有配置
            smooth: !isBarChart,
            symbol: !isBarChart ? 'circle' : 'emptyCircle',
            symbolSize: !isBarChart ? 8 : 4,
          },
          {
            name: "快递单数",
            type: chartType,
            data: this.statisticData.num2List,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#67c23a",
                },
                {
                  offset: 1,
                  color: "#95d475",
                },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#4e9e2e",
                  },
                  {
                    offset: 1,
                    color: "#67c23a",
                  },
                ]),
              },
            },
            label: {
              show: true,
              position: isBarChart ? "top" : "top",
            },
            // 折线图特有配置
            smooth: !isBarChart,
            symbol: !isBarChart ? 'circle' : 'emptyCircle',
            symbolSize: !isBarChart ? 8 : 4,
          },
          {
            name: "今日取镜订单数",
            type: chartType,
            data: this.statisticData.num3List,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#f56c6c",
                },
                {
                  offset: 1,
                  color: "#f8ad9d",
                },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#e74c3c",
                  },
                  {
                    offset: 1,
                    color: "#f56c6c",
                  },
                ]),
              },
            },
            label: {
              show: true,
              position: isBarChart ? "top" : "top",
            },
            // 折线图特有配置
            smooth: !isBarChart,
            symbol: !isBarChart ? 'circle' : 'emptyCircle',
            symbolSize: !isBarChart ? 8 : 4,
          },
          {
            name: "明日取镜订单数",
            type: chartType,
            data: this.statisticData.num4List,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#909399",
                },
                {
                  offset: 1,
                  color: "#c0c4cc",
                },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#606266",
                  },
                  {
                    offset: 1,
                    color: "#909399",
                  },
                ]),
              },
            },
            label: {
              show: true,
              position: isBarChart ? "top" : "top",
            },
            // 折线图特有配置
            smooth: !isBarChart,
            symbol: !isBarChart ? 'circle' : 'emptyCircle',
            symbolSize: !isBarChart ? 8 : 4,
          },
          {
            name: "后天取镜订单数",
            type: chartType,
            data: this.statisticData.num5List,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#e6a23c",
                },
                {
                  offset: 1,
                  color: "#f0c14b",
                },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#d48806",
                  },
                  {
                    offset: 1,
                    color: "#e6a23c",
                  },
                ]),
              },
            },
            label: {
              show: true,
              position: isBarChart ? "top" : "top",
            },
            // 折线图特有配置
            smooth: !isBarChart,
            symbol: !isBarChart ? 'circle' : 'emptyCircle',
            symbolSize: !isBarChart ? 8 : 4,
          }
        ],
      };

      try {
        // 设置图表选项 with null check
        if (this.chart && !this.chart.isDisposed()) {
          this.chart.setOption(option);
        }
      } catch (error) {
        console.error("Error setting chart option:", error);
      }
    },
    // Initialize chart and set up event listeners
    initChart() {
      // Get chart container
      const chartDom = document.querySelector(".statisticChart");
      if (chartDom) {
        // Initialize echarts instance
        this.chart = echarts.init(chartDom);
        // Set up resize listener with null check
        window.addEventListener("resize", () => {
          if (this.chart && !this.chart.isDisposed()) {
            this.chart.resize();
          }
        });
        
        // 添加legend选择事件监听器，确保至少保留一个选中项
        this.chart.on('legendselectchanged', (params) => {
          const selected = params.selected;
          let selectedCount = 0;
          let lastSelectedName = null;
          
          // 统计选中的数量并记录最后一个选中项
          for (const name in selected) {
            if (selected[name]) {
              selectedCount++;
              lastSelectedName = name;
            }
          }
          
          // 如果尝试取消所有选中项，强制保持最后一个选中
          if (selectedCount === 0 && lastSelectedName) {
            this.chart.dispatchAction({
              type: 'legendSelect',
              name: lastSelectedName
            });
          }
        });
      }
    },
    //获取统计数据
    GetJGBMonthKDStatistic() {
      GetJGBMonthKDStatistic(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            if (res.data) {
              this.statisticData.xnameList = [];
              this.statisticData.num1List = [];
              this.statisticData.num2List = [];
              this.statisticData.num3List = [];
              this.statisticData.num4List = [];
              this.statisticData.num5List = [];

              let list = res.data.dtls;
              list.forEach((item) => {
                this.statisticData.xnameList.push(item.xName);
                this.statisticData.num1List.push(item.count1);
                this.statisticData.num2List.push(item.count2);
                this.statisticData.num3List.push(item.count3);
                this.statisticData.num4List.push(item.count4);
                this.statisticData.num5List.push(item.count5);
              });
              // 数据更新后刷新图表 with proper check
              if (this.chart && !this.chart.isDisposed()) {
                // 调用changeChartType方法重新渲染整个图表，确保图表类型、标题等配置也能正确更新
                this.changeChartType();
              } else if (!this.chart) {
                // If chart instance doesn't exist, create one first
                this.initChart();
                this.changeChartType();
              }
            }
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        }).finally(() => {
          this.loading = false;
        });
    },
    // 时间选择
    changeDate(val) {
      if (val) {
        this.formInline.year = parseInt(val.split("-")[0]);
        this.formInline.month = parseInt(val.split("-")[1]);
      }
      this.GetJGBMonthKDStatistic();
    },
  },
};
</script>

<style scoped lang="scss">
.work_title_color {
  width: 5px;
  height: 20px;
  background-color: #409eff;
  display: inline-block;
  padding: 0;
  margin: 0;
}

.work_title {
  font-size: 16px;
  font-weight: 700;
  font-family: 微软雅黑;
  padding: 0;
  margin: 0;
  margin-left: 10px;
  display: inline-block;
}

.statisticChart {
  width: 100%;
  height: 600px;
  margin-top: 10px;
  padding-top: 20px;
  background-color: #fff;
  border-radius: 10px;
}
</style>